import { styled } from "@mui/material";

export const ContentsRow = styled("tr")({
  display: "contents",
});
